import { render, staticRenderFns } from "./DetailBranchComponent.vue?vue&type=template&id=0d74e79c&scoped=true"
import script from "./DetailBranchComponent.vue?vue&type=script&lang=js"
export * from "./DetailBranchComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailBranchComponent.vue?vue&type=style&index=0&id=0d74e79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74e79c",
  null
  
)

export default component.exports